// removed by extract-text-webpack-plugin
module.exports = {"float-right":"_3nIJy7Bwc58nxvkJvtE4JV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/questionnaire/Questionnaire.css
// module id = 782
// module chunks = 0